import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';

const imageDimension = 'min(612px, min(40vw, 51vh))';
const imageMobileDimension = '80vw';
const imageMobileMaxDimension = '328px';

export const signedOutModalStyles = {
	modalWrapper: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',

		outline: 'none',
	},
	modalBody: {
		maxHeight: { xs: 'fit-content', [tabletBreakpoint]: '80vh' },

		borderWidth: '1px',
		borderStyle: 'solid',
		borderColor: 'colors.dark4',
		borderRadius: '12px',

		backgroundColor: 'colors.dark6',

		display: 'flex',
		alignItems: 'center',
		gap: '16px',

		position: 'relative',
		overflow: 'hidden',
	},

	contentWrapper: {
		maxHeight: '80vh',
		overflow: { xs: 'auto', [tabletBreakpoint]: 'hidden' },
	},
	content: {
		flexDirection: { xs: 'column', [tabletBreakpoint]: 'row' },
		alignItems: 'stretch',
	},

	imgWrapper: {
		flexShrink: 0,
		width: { xs: imageMobileDimension, [tabletBreakpoint]: imageDimension },
		maxWidth: { xs: imageMobileMaxDimension, [tabletBreakpoint]: 'unset' },
		height: { xs: 'unset', [tabletBreakpoint]: imageDimension },
	},
	imgCont: {
		width: '100%',
		paddingTop: '100%',

		position: 'relative',
	},
	image: {
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,

		overflow: 'hidden',

		'& img': {
			height: '100%',
			width: '100%',
			objectFit: 'cover',
		},
	},

	textCont: {
		width: { xs: imageMobileDimension, [tabletBreakpoint]: 'min(512px, min(38vw, 55vh))' },
		maxWidth: { xs: imageMobileMaxDimension, [tabletBreakpoint]: 'unset' },
		padding: { xs: '24px 16px', [tabletBreakpoint]: '24px 24px' },

		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-evenly',
		alignItems: 'center',

		textAlign: 'center',

		overflow: 'hidden',

		'& svg': { height: { xs: '32px', [tabletBreakpoint]: '48px' }, width: 'auto' },
	},
	title: {
		color: 'colors.light1',
		typography: { xs: 'h2_medium', [tabletBreakpoint]: 'nd2' },
		fontWeight: 500,
	},
	subTitle: {
		typography: { xs: 'b1_regular', [tabletBreakpoint]: 'body1' },
		color: 'colors.light4',
	},

	continueWithGoogleButton: {
		width: '100%',
		maxWidth: '300px',
		padding: '8px 16px',
		borderRadius: '2px',

		backgroundColor: 'colors.white',
		textTransform: 'none',

		display: 'flex',
		alignItems: 'center',
		gap: '8px',

		'&:hover': { backgroundColor: 'colors.white' },

		'& img': { height: '24px', width: 'auto' },
	},
};
